export const videoPosts = `
  nodes {
    duration
    featuredImage {
      node {
        altText
        sourceUrl
      }
    }
    imageSrcset
    slug
    title
    videoId
  }
`;
